import { Component } from "react";
import "./App.css";

import { Link, withRouter } from "react-router-dom";

// React-MDL imports
import {
  Content,
  Footer,
  FooterLinkList,
  FooterSection,
  Header,
  Layout,
  Navigation,
} from "react-mdl";

// Main component Import
import Main from "./components/main";

class App extends Component {
  constructor(props) {
    super(props);
    const saved = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", saved);
    this.state = { theme: saved };
  }

  toggleTheme = () => {
    const next = this.state.theme === "light" ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", next);
    localStorage.setItem("theme", next);
    this.setState({ theme: next });
  };

  render() {
    const isDark = this.state.theme === "dark";
    const mdlRoutes = ["/tiktok", "/tiktok/contact", "/tiktok/privacy", "/tiktok/terms", "/help"];
    const isHolding = !mdlRoutes.includes(this.props.location.pathname);

    // Holding page has its own layout — render without MDL chrome
    if (isHolding) {
      return <Main />;
    }

    return (
      <div>
        <Layout fixedHeader>
          <Header
            transparent
            title={
              <Link style={{ textDecoration: "none", color: "var(--nav-text)" }} to="/">
                Rakeen
              </Link>
            }
            scroll
          >
            <Navigation>
              <Link
                to="/contact"
                style={{ textDecoration: "none", color: "var(--nav-text)" }}
              >
                Contact Us
              </Link>
              <Link
                to="/privacy"
                style={{ textDecoration: "none", color: "var(--nav-text)" }}
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                style={{ textDecoration: "none", color: "var(--nav-text)" }}
              >
                Terms of Services
              </Link>
              <button
                className="theme-toggle"
                onClick={this.toggleTheme}
                aria-label="Toggle dark mode"
                title={isDark ? "Switch to light mode" : "Switch to dark mode"}
              >
                {isDark ? "\u2600\uFE0F" : "\uD83C\uDF19"}
              </button>
            </Navigation>
          </Header>
          <Content>
            <div className="page-content" />
            <Main />
          </Content>
          <Footer
            size="mini"
            style={{ backgroundColor: "var(--footer-bg)", color: "var(--footer-text)" }}
          >
            <FooterSection type="left">
              <span>
                © {new Date().getFullYear()} Rakeen. All rights reserved.
              </span>
            </FooterSection>
            <FooterSection type="right">
              <FooterLinkList>
                <Link style={{ color: "var(--footer-text)" }} to="/privacy">
                  Privacy Policy
                </Link>
                <Link style={{ color: "var(--footer-text)" }} to="/terms">
                  Terms of Service
                </Link>
                <Link style={{ color: "var(--footer-text)" }} to="/contact">
                  Contact Us
                </Link>
              </FooterLinkList>
            </FooterSection>
          </Footer>
        </Layout>
      </div>
    );
  }
}

App = withRouter(App);

export default App;
